/**
 * @desc 费用扣减方式
 */
export const EXPENSE_DEDUCTION = new Map([
  [0, '无'],
  [1, '代理商支付'],
  [2, '扣减销售工资'],
  [3, '扣减代理商返利'],
  [4, '扣减阿米巴费用']
]);

/**
 * @desc smb 产品，产品行日期暂时放开到9月20日
 */
export const SMB_CONTRACT_NUM = ['NH11300164', 'NH11300163', 'NH11300127', 'NG13100242', 'NG10102282', 'NG13100486', 'NG10102257', 'NG13100063', 'NG13100064', 'NG13100586', 'NG13100573', 'NG13100153', 'NG13100579', 'NG13100192', 'NG13100581', 'NG13100582', 'NG13100575', 'NG13100460', 'NG10102255', 'NG13100102', 'NG13100101', 'NG13100527', 'NG10102256', 'NG13100155', 'NG13100066', 'NG13100457', 'NG13100251', 'NG13100458', 'NG13100065', 'NG13100342', 'NG13100479', 'NG13100067', 'NG13100065', 'NG13100459', 'NG13100241', 'NG13100252', 'NH11501324', 'NH11501325', 'NG11400105'];

/**
 * @desc 战略
 */
export const STRATEGY_LIST = [
  { label: '全部', value: '' },
  { label: '是', value: '0' },
  { label: '否', value: '1' }
];

/**
 * @desc 退换货原因展示名映射（key 为后端落库值 r_reason_type，不可修改）。
 *
 * 落库值属于持久化契约：`contract.r_contract_base.r_reason_type` 已存量数据、
 * 且 `returns` 侧 Mapper 直接以字面量参与 SQL 过滤，因此只能在实际取值上做
 * 展示层映射，禁止改写落库值。
 *
 * 2026-09-20 PRD 演示会待办 D8：退换货原因“发运错误”展示名更名为
 * “订单录入&发运差错”。（2026-09-22 按用户明确决策去掉末尾冗余的“退换货”三字：
 * 该名称本就出现在“退换货原因”语境中，重复“退换货”不增加信息量。）
 */
export const REASON_TYPE_DISPLAY = {
  产品发运错误: '订单录入&发运差错'
};

/**
 * @desc 按落库值取退换货原因展示名；未登记的原因原样返回。
 *
 * @param {string} reasonType 后端返回的退换货原因落库值
 * @returns {string} 用于界面展示的原因文案
 */
export function displayReasonType (reasonType) {
  if (!reasonType) return reasonType;
  return REASON_TYPE_DISPLAY[reasonType] || reasonType;
}
